<template>
  <v-card variant="outlined" class="bg-transparent register-card-container">
    <v-card-text class="pa-5">
      <div class="d-flex flex-column mb-5 justify-center align-center text-center ga-5">
        <h2 class="fs-24 font-weight-medium">
          {{ content.selection_heading }}
        </h2>
        <p class="fs-16">{{ content.selection_helper_text }}</p>
        <RegistrationUnavailableAlert
          v-if="eventData?.payment_processing_available === false"
          class="w-100 text-left"
        />
      </div>
      <div class="d-flex flex-column ga-5">
        <v-card v-if="shouldShowGuestOption" variant="outlined" class="mx-auto register-card">
          <div class="px-6 py-8">
            <h3 class="fs-20 font-weight-light-bold mb-2">
              {{ content.guest_card_title }}
            </h3>
            <p class="fs-14 color-neutral-500 mb-3">
              {{ content.guest_card_helper_text }}
            </p>
            <v-tooltip
              :disabled="eventData.registration_open"
              location="top"
              content-class="white-tooltip"
            >
              <template #activator="{ props }">
                <span v-bind="props" class="d-inline-block w-100">
                  <v-btn
                    @click="() => handleSelectionClick('tickets')"
                    class="text-transform-none"
                    append-icon="mdi-arrow-right"
                    :color="eventData?.event_color || '#0E6CB3'"
                    variant="flat"
                    block
                    :disabled="!eventData.registration_open"
                    :style="{ pointerEvents: eventData.registration_open ? 'auto' : 'none' }"
                  >
                    {{ content.guest_button_prefix }}
                    <!-- {{ eventData?.ticketCustomLabel || "Guest" }} -->
                  </v-btn>
                </span>
              </template>
              {{ content.closed_registration_tooltip }}
            </v-tooltip>
          </div>
        </v-card>
        <v-card v-if="shouldShowTableOption" variant="outlined" class="mx-auto register-card">
          <div class="px-6 py-8">
            <h3 class="fs-20 font-weight-light-bold mb-2">
              {{ content.table_card_title }}
            </h3>
            <p class="fs-14 color-neutral-500 mb-3">
              {{ content.table_card_helper_text }}
            </p>
            <v-tooltip
              :disabled="eventData.registration_open"
              location="top"
              content-class="white-tooltip"
            >
              <template #activator="{ props }">
                <span v-bind="props" class="d-inline-block w-100">
                  <v-btn
                    @click="() => handleSelectionClick('tables')"
                    class="text-transform-none"
                    append-icon="mdi-arrow-right"
                    :color="eventData?.event_color || '#0E6CB3'"
                    variant="flat"
                    block
                    :disabled="!eventData.registration_open"
                    :style="{ pointerEvents: eventData.registration_open ? 'auto' : 'none' }"
                  >
                    {{ content.table_button_prefix }}
                    <!-- {{ eventData?.tableCustomLabel || "Table Host" }} -->
                  </v-btn>
                </span>
              </template>
              {{ content.closed_registration_tooltip }}
            </v-tooltip>
          </div>
        </v-card>
        <v-card v-if="shouldShowSponsorOption" variant="outlined" class="mx-auto register-card">
          <div class="px-6 py-8">
            <h3 class="fs-20 font-weight-light-bold mb-2">
              {{ content.sponsor_card_title }}
            </h3>
            <p class="fs-14 color-neutral-500 mb-3">
              {{ content.sponsor_card_helper_text }}
            </p>
            <v-tooltip
              :disabled="eventData.registration_open"
              location="top"
              content-class="white-tooltip"
            >
              <template #activator="{ props }">
                <span v-bind="props" class="d-inline-block w-100">
                  <v-btn
                    @click="() => handleSelectionClick('sponsors')"
                    class="text-transform-none"
                    append-icon="mdi-arrow-right"
                    :color="eventData?.event_color || '#0E6CB3'"
                    variant="flat"
                    block
                    :disabled="!eventData.registration_open"
                    :style="{ pointerEvents: eventData.registration_open ? 'auto' : 'none' }"
                  >
                    {{ content.sponsor_button_prefix }}
                    <!-- {{ eventData?.eventSponsorCustomLabel || "Sponsor" }} -->
                  </v-btn>
                </span>
              </template>
              {{ content.closed_registration_tooltip }}
            </v-tooltip>
          </div>
        </v-card>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { computed } from 'vue';
import RegistrationUnavailableAlert from '~/components/attendance/RegistrationUnavailableAlert.vue';

const props = defineProps({
  eventData: Object,
  shouldShowGuestOption: Boolean,
  shouldShowTableOption: Boolean,
  shouldShowSponsorOption: Boolean,
  handleSelectionClick: Function,
});

const content = computed(() => {
  return props.eventData?.registration_page_content || {};
});
</script>

<style scoped>
.register-card-container {
  border: 1px solid #e5e5e5;
}
.register-card {
  border: 1px solid #e5e5e5;
  width: 100%;
}
.color-neutral-500 {
  color: var(--fundeasy-colors-neutral-500);
}
</style>
<style>
.white-tooltip {
  background-color: white !important;
  color: black !important;
  font-weight: 400;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
}
</style>
